// Component: footer-newsletter — AJAX submit + state management.
// Event delegation per Rule J2. Progressive enhancement only: if JS fails or is disabled,
// Shopify's native {% form 'customer' %} submission re-renders with form.posted_successfully?
// / form.errors populated in the Liquid-rendered message region.
// Shopify's /contact endpoint has no documented AJAX JSON contract — we treat any 2xx/3xx
// response as success and any 4xx/5xx as error. Server-rendered messages remain canonical.

(function () {
  if (window.__footerNewsletterHandlerBound) return;
  window.__footerNewsletterHandlerBound = true;

  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form || !form.matches('.footer-newsletter__form')) return;

    const wrap = form.closest('.footer-newsletter');
    if (!wrap) return;

    e.preventDefault();

    const submit = form.querySelector('.footer-newsletter__submit');
    const messageEl = form.querySelector('.footer-newsletter__message');

    wrap.setAttribute('data-state', 'loading');
    if (submit) submit.setAttribute('disabled', '');

    try {
      const body = new FormData(form);
      const res = await fetch(form.action, {
        method: 'POST',
        body,
        headers: { Accept: 'application/json, text/html;q=0.9, */*;q=0.8' },
      });

      if (res.ok || (res.status >= 300 && res.status < 400)) {
        wrap.setAttribute('data-state', 'success');
        if (messageEl) {
          const existingSuccess = messageEl.querySelector('.footer-newsletter__success');
          if (!existingSuccess) {
            const successTpl = wrap.getAttribute('data-success-message') || 'Thanks for subscribing.';
            messageEl.innerHTML = '<p class="footer-newsletter__success">' + escapeHtml(successTpl) + '</p>';
          }
        }
      } else {
        throw new Error('HTTP ' + res.status);
      }
    } catch (err) {
      wrap.setAttribute('data-state', 'error');
      if (submit) submit.removeAttribute('disabled');
      if (messageEl && !messageEl.querySelector('.footer-newsletter__error')) {
        messageEl.innerHTML = '<p class="footer-newsletter__error">Something went wrong. Please try again.</p>';
      }
    }
  });

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
})();
